import { GAME_NUMBERS } from '@/components/constants/constants';
import { MatchScoreState } from '@/components/molecules/ScoreCards/modals/MatchScorecardModal';
import { ScoreInput } from '@/components/molecules/ScoreCards/ScoreInput';
import { MatchupStatusEnum } from '@/domain/constants/constants';
import { GameScore } from '@/entities/score/GameScore';
import { GameStatus } from '@/entities/score/GameStatus';
import { shouldMarkGameAsWon } from '@/utils/score-utils';

interface Props {
	state: MatchScoreState;
	updateScore: (gameNumber: number, team: 'away' | 'home', newValue: GameScore) => void;
	onRetireOrForfeitSelect: (side: 'away' | 'home', type: 'forfeit' | 'retire' | 'undo', gameNumber: number) => void;
	matchupStatus: MatchupStatusEnum;
	awayTeamFinalScore: number;
	homeTeamFinalScore: number;
	winner: number;
	isLocked: boolean;
	gameStatuses: GameStatus[];
}

export const MatchScoreWrapper = ({
	state,
	updateScore,
	onRetireOrForfeitSelect,
	matchupStatus,
	awayTeamFinalScore,
	homeTeamFinalScore,
	winner,
	isLocked,
	gameStatuses
}: Props) => {
	return (
		<div className="flex flex-col gap-3">
			<div className="flex items-start justify-center gap-3 md:gap-5">
				{state.games.map((game, i) => (
					<ScoreInput
						key={i}
						value={game.away}
						matchWinner={false}
						matchupStatus={matchupStatus}
						gameNumber={`${i + 1}`}
						onChange={updateScore}
						team="away"
						onRetireOrForfeitSelect={onRetireOrForfeitSelect}
						isLocked={isLocked}
						isGameWinner={shouldMarkGameAsWon(gameStatuses[i]!, game.away.score, game.home.score, 'away')}
					/>
				))}
				<ScoreInput
					value={{ isForfeited: false, isRetired: false, score: awayTeamFinalScore, isUndo: false }}
					matchWinner={winner === 2}
					matchupStatus={matchupStatus}
					onChange={updateScore}
					team="away"
					gameNumber={GAME_NUMBERS.FINAL}
					isLocked
					isGameWinner={false}
				/>
			</div>
			<div className="flex items-center gap-4 w-full">
				<div className="flex-grow border-t border-gray-300" />
				<span className="text-gray-300 font-semibold">vs</span>
				<div className="flex-grow border-t border-gray-300" />
			</div>
			<div className="flex items-start justify-center gap-3 md:gap-5">
				{state.games.map((game, i) => (
					<ScoreInput
						key={i}
						value={game.home}
						matchWinner={false}
						matchupStatus={matchupStatus}
						gameNumber={`${i + 1}`}
						onChange={updateScore}
						team="home"
						onRetireOrForfeitSelect={onRetireOrForfeitSelect}
						isLocked={isLocked}
						isGameWinner={shouldMarkGameAsWon(gameStatuses[i]!, game.away.score, game.home.score, 'home')}
					/>
				))}
				<ScoreInput
					value={{ isForfeited: false, isRetired: false, score: homeTeamFinalScore, isUndo: false }}
					matchWinner={winner === 1}
					matchupStatus={matchupStatus}
					onChange={updateScore}
					team="home"
					gameNumber={GAME_NUMBERS.FINAL}
					isLocked
					isGameWinner={false}
				/>
			</div>
		</div>
	);
};
